<template>
  <v-footer tile inset absolute padless class="asc-footer">
    <v-container fluid>
      <div class="d-flex justify-space-between asc-footer--box">
        <div class="d-flex justify-left align-center" style="max-width: 55%">
          <span class="asc-footer--text text-left">{{ text }}</span>
        </div>
        <div class="d-flex flex-wrap align-center">
          <span class="asc-footer--link d-flex align-center">
            <a
              href="https://arinconline.collinsaerospace.com/terms-of-use/"
              rel="noopener noreferrer"
              target="_blank"
              >{{ 'Terms of Use' }}
            </a>
            <v-divider class="mx-2" vertical></v-divider>
          </span>
          <span class="asc-footer--link d-flex align-center">
            <a
              href="https://www.rtx.com/privacy"
              rel="noopener noreferrer"
              target="_blank"
              >{{ 'Privacy Policy' }}
            </a>
            <v-divider class="mx-2" vertical></v-divider>
          </span>
          <span class="asc-footer--signature" cols="2">
            &copy; {{ currentYear }} Collins Aerospace
          </span>
        </div>
      </div></v-container
    >
  </v-footer>
</template>

<script>
export default {
  name: 'AscFooter',

  props: {
    text: {
      type: String,
      default: '',
    },
    currentYear: {
      type: Number,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-footer {
  // container padding of 16px*2
  width: 100%;
  background-color: $primary-white !important;

  @media only screen and (max-width: 900px) {
    height: auto !important;
  }

  &--text {
    padding: 0;
    margin: 0 auto;
    color: $gray-1000;
    font-size: 12px;
    letter-spacing: 0.30000001192092896px;
    line-height: 14px;
    font-weight: 400;
    text-align: left;
  }
  &--link {
    //styleName: NEW Descriptive Text;

    font-size: 12px;
    font-weight: 400;

    text-align: right;

    a {
      text-decoration: none;
      color: $secondary-400 !important;
    }
  }
  &--signature {
    font-size: 12px;
    font-weight: 400;

    text-align: center;
  }
  &--box {
    margin-inline: 8px;
  }
}

.asc-content-wrapper--container {
  &.hasScroll {
    .asc-footer {
      // container padding of 16px*2 + scrollbar width 0f 8px
      width: 100%;
    }
  }
}
</style>
